<template>
  <div class="pl-2">
    Detail Content

  </div>
</template>

<script>
export default {
  name: 'OrganizationsDetailContent',
  components: {
  },
  props: {},
  data () {
    return {}
  },
  computed: {},
  methods: {},
  created () {}
}
</script>

<style lang="scss" scoped>

</style>
